import React, { useState } from "react";
import "./Shop.scss";
import List from "../../components/List/List";
import { Link, useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { useEffect } from "react";
import axios from "axios";
import Card from "../../components/Card/Card";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Loading from "../../components/loading/Loading";

const Shop = () => {
  const { buyer } = useContext(AuthContext);
  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const value = category;

  useEffect(() => {
    const getCatagory = async () => {
      try {
        const response = await axios.get("/get-all-cetegory");
        setCategory(response.data);
      } catch (error) {
        return;
      }
    };
    getCatagory();
  }, []);

  useEffect(() => {
    const getAllProduct = async () => {
      try {
        setLoading(true)
        const response = await axios.get("/get-all-product", {
          params: selectCategory ? { category: selectCategory } : {},
        });
        setProducts(response.data);
      } catch (error) {
        return;
      }finally{
        setLoading(false)
      }
    };
    getAllProduct();
  }, [selectCategory]);

  return (
    <div className="__fw">
      <div className="__mw">
        <div className="products">
          <div className="left">
            <div className="filterItem">
              <div className="cat_head">
                <span>
                  Product <em>Categories</em>
                </span>
              </div>
              {category?.map((item, i) => (
                <div className="inputItem" key={item._id}>
                  <input
                    type="radio"
                    id={item._id}
                    name="category"
                    value={item.category}
                    onChange={(e) => setSelectCategory(e.target.value)}
                  />
                  <span className="ft">{item.category}</span>
                </div>
              ))}
              <div className="inputItem">
                <input
                  type="radio"
                  id="all"
                  name="category"
                  value=""
                  checked={selectCategory === ""}
                  onChange={() => setSelectCategory("")}
                />
                <span className="ft">All Products</span>
              </div>
            </div>
          </div>

          {loading ? (
            <>
              <Loading />
            </>
          ) : (
            <div className="right">
              {/* <div className="c_banner">
                <img src={require("../../img/och_nb.jpg")} alt="" />
              </div> */}
              <div className="right_in">
                {products.length === 0 ? (
                  <>
                    <div></div>
                    <div className="no_pro">
                      <p
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          color: "#666",
                        }}
                      >
                        No products found for this category.
                      </p>
                    </div>
                    <div></div>
                  </>
                ) : (
                  <>
                    {products.map((item, i) => (
                      <Card key={i} item={item} />
                    ))}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Shop;
